export class DepInformationsComplementaires {
  depTypeSlug: string;

  constructor(depTypeSlug: string) {
    this.depTypeSlug = depTypeSlug;
  }

  static factory(
    depInformationsComplementairesAPI: DepInformationsComplementairesAPI,
  ): DepInformationsComplementaires {
    return new DepInformationsComplementaires(
      depInformationsComplementairesAPI.dep_type_slug,
    );
  }

  toAPI(): DepInformationsComplementairesAPI {
    return {
      dep_type_slug: this.depTypeSlug,
    };
  }
}

export type DepInformationsComplementairesAPI = {
  dep_type_slug: string;
};
